// extracted by mini-css-extract-plugin
module.exports = {"pillContainer":"RFrEinNV","styledHeader":"t9YnS7a4","assetHeader":"ATvd6ocu","styledLogoImg":"GrbQtEFJ","logoFallback":"ZJlnuTV8"};